import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { fmtNum } from "../../lib/format";
import { PageTitle, Spinner } from "../../components/Shell";

export default function Usage() {
  const [usage, setUsage] = useState(null);

  useEffect(() => {
    api.get("/platform/usage").then((r) => setUsage(r.data.usage)).catch(() => {});
  }, []);

  if (!usage) return <Spinner />;

  return (
    <div data-testid="platform-usage">
      <PageTitle title="Penggunaan Penyewa" sub="Ahli, transaksi, AI & jejak audit setiap penyewa" />
      <div className="bg-card rounded-xl border border-brand-deep/10 overflow-x-auto">
        <table className="w-full text-sm min-w-[720px]">
          <thead>
            <tr className="border-b border-brand-deep/10 text-left text-xs uppercase tracking-wider text-muted-foreground">
              <th className="px-5 py-3">Koperasi</th>
              <th className="px-5 py-3">Pelan</th>
              <th className="px-5 py-3 text-right">Ahli</th>
              <th className="px-5 py-3 text-right">Bayaran</th>
              <th className="px-5 py-3 text-right">Mesej AI</th>
              <th className="px-5 py-3 text-right">Log Audit</th>
            </tr>
          </thead>
          <tbody>
            {usage.map((u) => (
              <tr key={u.tenant_id} className="border-b border-brand-deep/5" data-testid={`usage-row-${u.tenant_id.slice(-6)}`}>
                <td className="px-5 py-3 font-medium text-brand-dark">{u.name}</td>
                <td className="px-5 py-3 uppercase text-xs font-bold text-brand-deep">{u.plan}</td>
                <td className="px-5 py-3 text-right font-mono">{fmtNum(u.members)}{u.member_limit > 0 && <span className="text-muted-foreground"> / {fmtNum(u.member_limit)}</span>}</td>
                <td className="px-5 py-3 text-right font-mono">{fmtNum(u.payments)}</td>
                <td className="px-5 py-3 text-right font-mono">{fmtNum(u.ai_messages)}</td>
                <td className="px-5 py-3 text-right font-mono">{fmtNum(u.audit_logs)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
